import { Button, IconButton, InputBase, Modal, Paper } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import download from "../assets/download.png";
import Facebook from "../assets/facebook.png";
import instagram from "../assets/instagram.png";
import sharinglink from "../assets/sharinglink.png";
import X from "../assets/x.png";

import Whatsapp from "../assets/whatsapp.png";
import { toast } from "react-toastify";
function Sharecontentmodal({
  isShareModalOpen,
  setShareModalOpen,
  ModuleName,
  link,
  isMobileview,
  mp3Link,
  podcastTitle,
}) {
  return (
    <Modal
      open={isShareModalOpen}
      onClose={() => {
        setShareModalOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobileview ? "70%" : ModuleName == "Podcast" ? "27%" : "22%",
          bgcolor: "background.paper",
          p: isMobileview ? 2 : 4,
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          padding: "25px",
          fontWeight: "500",
          fontSize: "16px",
          borderRadius: isMobileview ? "10px" : "20px",
        }}
      >
        Share this Via link
        <Box
          style={{ display: "flex" }}
          justifyContent={"space-between"}
          marginTop={"10px"}
          marginBottom={"10px"}
        >
          <Box
            style={{
              width: isMobileview ? "21px" : "24px",
              height: isMobileview ? "21px" : "24px",
              padding: isMobileview ? "8px" : "14px",
              border: "1px solid #D3D3D3",
              borderRadius: "50px",
              cursor: "pointer",
            }}
          >
            <img
              src={Whatsapp}
              style={{
                width: isMobileview ? "21px" : "24px",
                height: isMobileview ? "21px" : "24px",
                borderRadius: "0px",
              }}
              onClick={() => {
                if (isMobileview) {
                  window
                    .open(
                      `https://wa.me/?text=Check%20this%20out!%20=${link}`,
                      "_blank"
                    )
                    .focus();
                } else {
                  window
                    .open(
                      `https://wa.me/?text=Check%20this%20out!%20=${link}`,
                      "_blank"
                    )
                    .focus();
                }
              }}
            />
          </Box>
          <Box
            style={{
              width: isMobileview ? "21px" : "24px",
              height: isMobileview ? "21px" : "24px",
              padding: isMobileview ? "8px" : "14px",
              border: "1px solid #D3D3D3",
              borderRadius: "50px",
              cursor: "pointer",
            }}
          >
            <img
              src={instagram}
              style={{
                width: isMobileview ? "21px" : "24px",
                height: isMobileview ? "21px" : "24px",
                borderRadius: "0px",
              }}
              onClick={() => {
                if (isMobileview) {
                  window
                    .open(`instagram://library?AssetPath=${link}`, "_blank")
                    .focus();
                } else {
                  window
                    .open(`https://www.instagram.com/?url=${link}`, "_blank")
                    .focus();
                }
              }}
            />
          </Box>
          <Box
            style={{
              width: isMobileview ? "21px" : "24px",
              height: isMobileview ? "21px" : "24px",
              padding: isMobileview ? "8px" : "14px",
              border: "1px solid #D3D3D3",
              borderRadius: "50px",
              cursor: "pointer",
            }}
          >
            <img
              src={Facebook}
              style={{
                width: isMobileview ? "21px" : "24px",
                height: isMobileview ? "21px" : "24px",
                borderRadius: "0px",
              }}
              onClick={() => {
                if (isMobileview) {
                  window
                    .open(`fb://facewebmodal/f?href=${link}`, "_blank")
                    .focus();
                } else {
                  window
                    .open(
                      `https://www.facebook.com/sharer/sharer.php?u==${link}`,
                      "_blank"
                    )
                    .focus();
                }
              }}
            />
          </Box>
          <Box
            style={{
              width: isMobileview ? "21px" : "24px",
              height: isMobileview ? "21px" : "24px",
              padding: isMobileview ? "8px" : "14px",
              border: "1px solid #D3D3D3",
              borderRadius: "50px",
              cursor: "pointer",
            }}
          >
            <img
              src={X}
              style={{
                width: isMobileview ? "21px" : "24px",
                height: isMobileview ? "21px" : "24px",
                borderRadius: "0px",
              }}
              onClick={() => {
                if (isMobileview) {
                  window
                    .open(
                      `twitter://post?message=Check%20this%20out!%20=${link}`,
                      "_blank"
                    )
                    .focus();
                } else {
                  window
                    .open(
                      `https://twitter.com/intent/tweet?url=${link}`,
                      "_blank"
                    )
                    .focus();
                }
              }}
            />
          </Box>
          {ModuleName == "Podcast" && (
            <img
              src={download}
              style={{
                width: isMobileview ? "23px" : "26px",
                height: isMobileview ? "21px" : "24px",
                padding: isMobileview ? "8px" : "14px",
                border: "1px solid #D3D3D3",
                borderRadius: "50px",
                cursor: "pointer",
              }}
              onClick={() => {
                // const url = window.URL.createObjectURL(mp3Link);
                // const a = document.createElement("a");
                // a.style.display = "none";
                // a.href = mp3Link;
                // a.download = podcastTitle;
                // document.body.appendChild(a);
                // a.click();
                // window.URL.revokeObjectURL(mp3Link);
                window.open(mp3Link, "_blank").focus();
              }}
            />
          )}
        </Box>
        Or copy {ModuleName} link
        <Box style={{ display: "flex", gap: "10px" }} marginTop={"10px"}>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 400,
              border: "1px solid #D3D3D3",
              borderRadius: "8px",
            }}
          >
            <IconButton sx={{ p: "3px" }} aria-label="menu">
              <img
                src={sharinglink}
                style={{ width: "22px", height: "22px" }}
              />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              // placeholder={link}
              style={{ color: "rgb(10, 31, 192)" }}
              value={link}
              inputProps={{ "aria-label": "seaddrch google maps" }}
            />
          </Paper>
          <Button
            variant="contained"
            borderRadius={"8px"}
            onClick={() => {
              navigator?.clipboard.writeText(link);
              toast.success("Copied", {
                position: "top-center",
                autoClose: 1000,
              });
            }}
          >
            {" "}
            Copy
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default Sharecontentmodal;
